import { useEffect, useState } from "react";

const normalize = () => {
  const value = window.location.hash.replace(/^#\/?/, "");
  return value.split(/[/?]/)[0] || "dashboard";
};

export function navigate(route) {
  window.location.hash = `#/${route}`;
}

export function useHashRoute() {
  const [route, setRoute] = useState(normalize);
  useEffect(() => {
    const listener = () => setRoute(normalize());
    window.addEventListener("hashchange", listener);
    return () => window.removeEventListener("hashchange", listener);
  }, []);
  return [route, navigate];
}
